import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

/**
 * Determines if the empty folder button should be shown for the corresponding folder or not
 * @param folderId
 */
export const shouldShowEmptyFolderButtonForFolderId = (folderId: string): boolean => {
    if (!folderId) {
        return false;
    }
    const folderName = folderIdToName(folderId);
    return folderName === 'deleteditems' || folderName === 'junkemail';
};
